module.exports = __webpack_public_path__ + "assets/tongyong.cfcbedf3.svg";